/* Look detail — 'Passende Looks' horizontale scroller met prev/next knoppen */
(function () {
  function initScroller(scroller) {
    if (scroller.dataset.lkdScroller === 'bound') return;

    const track = scroller.querySelector('[data-lkd-related-track]');
    if (!track) return;

    scroller.dataset.lkdScroller = 'bound';

    const prevBtn = scroller.querySelector('[data-lkd-related-prev]');
    const nextBtn = scroller.querySelector('[data-lkd-related-next]');

    function step() {
      const item = track.querySelector('.lkd-related-item');
      const gap = parseFloat(getComputedStyle(track).gap) || 24;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    }

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  }

  function init() {
    document.querySelectorAll('.lkd-related-scroller').forEach(initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();

/* Look detail — variantkeuze-popup bij toevoegen aan winkelwagen */
(function () {
  const strings = window.lookStrings || {};

  let modal;
  let imageEl;
  let vendorEl;
  let titleEl;
  let priceEl;
  let optionsEl;
  let submitBtn;
  let feedbackEl;
  let currentProduct = null;
  let selectedOptions = {};
  let lastFocusedEl = null;
  let escapeBound = false;

  function findModalRefs() {
    modal = document.querySelector('[data-lkd-size-modal]');
    if (!modal) return false;
    imageEl = modal.querySelector('[data-lkd-modal-image]');
    vendorEl = modal.querySelector('[data-lkd-modal-vendor]');
    titleEl = modal.querySelector('[data-lkd-modal-title]');
    priceEl = modal.querySelector('[data-lkd-modal-price]');
    optionsEl = modal.querySelector('[data-lkd-modal-options]');
    submitBtn = modal.querySelector('[data-lkd-modal-submit]');
    feedbackEl = modal.querySelector('[data-lkd-modal-feedback]');
    return true;
  }

  function optionPositions() {
    return (currentProduct?.options || []).map((option) => option.position);
  }

  function findMatchingVariant() {
    if (!currentProduct) return null;

    const positions = optionPositions();
    // Every option needs a value before a variant can be identified.
    if (!positions.length || positions.some((position) => !selectedOptions[position])) return null;

    return (currentProduct.variants || []).find((variant) =>
      positions.every((position) => variant['option' + position] === selectedOptions[position])
    ) || null;
  }

  function setFeedback(message) {
    feedbackEl.textContent = message || '';
    if (message) {
      feedbackEl.setAttribute('data-error', 'true');
    } else {
      feedbackEl.removeAttribute('data-error');
    }
  }

  function updateSubmitState() {
    const variant = findMatchingVariant();

    if (variant && variant.available) {
      submitBtn.disabled = false;
      submitBtn.setAttribute('data-variant-id', variant.id);
      setFeedback('');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.removeAttribute('data-variant-id');
    setFeedback(variant ? strings.outOfStock : '');
  }

  function buildOptionSelects(product) {
    optionsEl.innerHTML = '';
    selectedOptions = {};

    (product.options || []).forEach((option) => {
      const values = option.values || [];

      // Nothing to pick when there is only one value — think of a product that
      // only comes in one colour, or the default "Title" option.
      if (values.length <= 1) {
        selectedOptions[option.position] = values[0] || null;
        return;
      }

      const label = document.createElement('label');
      label.className = 'lkd-size-modal-option';
      label.textContent = option.name;

      const select = document.createElement('select');
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = strings.choose || option.name;
      select.appendChild(placeholder);

      values.forEach((value) => {
        const optionEl = document.createElement('option');
        optionEl.value = value;
        optionEl.textContent = value;
        select.appendChild(optionEl);
      });

      select.addEventListener('change', () => {
        selectedOptions[option.position] = select.value || null;
        updateSubmitState();
      });

      label.appendChild(select);
      optionsEl.appendChild(label);
    });

    updateSubmitState();
  }

  function openModal(product, triggerEl) {
    if (!modal && !findModalRefs()) return;

    currentProduct = product;
    lastFocusedEl = triggerEl || document.activeElement;

    if (product.image) imageEl.src = product.image;
    imageEl.alt = product.title || '';
    vendorEl.textContent = product.vendor || '';
    titleEl.textContent = product.title || '';
    priceEl.textContent = product.price || '';
    setFeedback('');

    buildOptionSelects(product);

    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    const panel = modal.querySelector('.lkd-size-modal-panel');
    trapFocus(panel || modal, optionsEl.querySelector('select') || submitBtn);
  }

  function closeModal() {
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    document.body.style.overflow = '';
    currentProduct = null;
    removeTrapFocus(lastFocusedEl);
  }

  function addToCart(variantId) {
    const notification = document.querySelector('cart-notification');
    const sections = notification?.getSectionsToRender
      ? notification.getSectionsToRender().map((section) => section.id)
      : ['cart-icon-bubble'];

    return fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then((response) => response.json().then((data) => {
        if (!response.ok || data.status) throw new Error(data.description || strings.error);
        return data;
      }));
  }

  function renderCartUpdate(parsedState, activeElement) {
    const notification = document.querySelector('cart-notification');

    // Use the theme's own cart notification so the drawer, the bubble and the
    // notification all stay in sync — same flow as product-form.js.
    if (notification?.renderContents) {
      notification.setActiveElement(activeElement);
      notification.renderContents(parsedState);
      return;
    }

    const bubbleHTML = parsedState.sections?.['cart-icon-bubble'];
    const currentBubble = document.getElementById('cart-icon-bubble');
    if (!bubbleHTML || !currentBubble) return;

    const newBubble = new DOMParser()
      .parseFromString(bubbleHTML, 'text/html')
      .getElementById('cart-icon-bubble');
    if (newBubble) currentBubble.replaceWith(newBubble);
  }

  function handleSubmit() {
    const variantId = submitBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    const activeElement = lastFocusedEl;

    submitBtn.disabled = true;
    setFeedback('');

    addToCart(variantId)
      .then((data) => {
        closeModal();
        renderCartUpdate(data, activeElement);
      })
      .catch((error) => {
        setFeedback(error.message || strings.error);
        submitBtn.disabled = false;
      });
  }

  function init() {
    if (!findModalRefs()) return;

    document.querySelectorAll('[data-lkd-open-picker]').forEach((btn) => {
      if (btn.disabled || btn.dataset.lkdPicker === 'bound') return;
      btn.dataset.lkdPicker = 'bound';

      btn.addEventListener('click', () => {
        const scriptEl = btn.parentElement.querySelector('[data-lkd-product-data]');
        if (!scriptEl) return;

        try {
          openModal(JSON.parse(scriptEl.textContent), btn);
        } catch (error) {
          console.error('Look detail: could not read product data', error);
        }
      });
    });

    modal.querySelectorAll('[data-lkd-size-modal-close]').forEach((el) => {
      if (el.dataset.lkdClose === 'bound') return;
      el.dataset.lkdClose = 'bound';
      el.addEventListener('click', closeModal);
    });

    if (submitBtn.dataset.lkdSubmit !== 'bound') {
      submitBtn.dataset.lkdSubmit = 'bound';
      submitBtn.addEventListener('click', handleSubmit);
    }

    if (!escapeBound) {
      escapeBound = true;
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeModal();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
